import React from 'react';
import { Navbar, Nav } from "react-bootstrap";
import HeaderBrand from "./HeaderBrand";
import HeaderSwitch from "./HeaderSwitch";


const Header = (props) => {
  return (
    <div>
      <Navbar fluid collapseOnSelect>
        <HeaderBrand />
        <Navbar.Collapse>
          <Nav pullRight>
            <HeaderSwitch
              isAuthenticated={props.isAuthenticated}
              clickedLogout={props.clickedLogout}
            />
          </Nav>
      </Navbar.Collapse>
      </Navbar>
    </div>
  )
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/Header/Header.js